import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { LanguageService } from '../../services/language.service';
import { BnNumberPipe } from '../../pipes/bn-number.pipe';

@Component({
  selector: 'app-purchase-management',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    BnNumberPipe
  ],
  templateUrl: './purchase-management.html',
  styleUrls: ['./purchase-management.css']
})
export class PurchaseManagement implements OnInit {

  apiUrl =
    'https://superbangladesh-api-1.onrender.com';

  products: any[] = [];

  categories: string[] = [];
  suppliers: any[] = [];

 purchase: any = {

  supplierId: null,

  supplierName: '',
  supplierContact: '',

  paidAmount: 0,

  items: [
    {
      category: '',
      productId: '',
      search: '',
      quantity: 1,
      unitPrice: 0,
      sellPrice: 0
    }
  ]
};

  constructor(
    private http: HttpClient,
    public languageService: LanguageService
  ) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }

 ngOnInit(): void {

  this.loadProducts();

  this.loadSuppliers();
}

onSupplierChange() {

  console.log(
    'Selected ID:',
    this.purchase.supplierId
  );

  console.log(
    'All Suppliers:',
    this.suppliers
  );

  const supplier = this.suppliers.find(
    s => s.id == this.purchase.supplierId
  );

  console.log(
    'Found Supplier:',
    supplier
  );

  if (!supplier) return;

  this.purchase.supplierName =
    supplier.name;

  this.purchase.supplierContact =
    supplier.phone;
}

  // IMAGE URL
  getImage(url: string) {

    if (!url) {
      return 'assets/no-image.png';
    }

    return `${this.apiUrl}/images/${url}`;
  }

  // LOAD PRODUCTS
  loadProducts() {

    this.http.get<any[]>(
      `${this.apiUrl}/api/products`
    )
    .subscribe({

      next: (res) => {

        console.log(
          'PRODUCTS:',
          res
        );

        this.products = res || [];

        this.categories = [

          ...new Set(

            this.products
              .map(
                p => p.category?.name
              )
              .filter(Boolean)

          )

        ] as string[];
      },

      error: (err) => {

        console.log(
          'PRODUCT ERROR:',
          err
        );
      }
    });
  }

loadSuppliers() {

  this.http.get<any[]>(

    `${this.apiUrl}/api/suppliers`

  ).subscribe({

    next: (res) => {

      console.log(
        'SUPPLIERS:',
        res
      );

      this.suppliers = res || [];

    },

    error: (err) => {

      console.log(
        'SUPPLIER ERROR:',
        err
      );

    }

  });
}

  // SELECT PRODUCT
  selectProduct(
    item: any,
    product: any
  ) {

    item.productId = product.id;

    item.search = product.name;

    item.sellPrice =
      product.price || 0;
  }

  // SELECTED PRODUCT
  getSelectedProduct(
    productId: any
  ) {

    return this.products.find(
      p => p.id == productId
    );
  }

  // SERVER SEARCH — ৪৬ হাজার+ প্রোডাক্ট একসাথে না এনে, টাইপ করলে সার্ভার থেকে খুঁজে
  // `products` তালিকায় যোগ করা হয় (আগের ফিল্টার কোড অপরিবর্তিত থাকে)
  private searchTimer: any;

  onItemSearch(item: any) {

    const q = (item?.search || '').trim();

    clearTimeout(this.searchTimer);

    if (q.length < 2) return;

    this.searchTimer = setTimeout(() => {

      this.http.get<any[]>(
        `${this.apiUrl}/api/products/search`,
        { params: { keyword: q } }
      ).subscribe({

        next: (res) => {

          const have = new Set(this.products.map(p => p.id));

          for (const p of res || []) {
            if (!have.has(p.id)) {
              this.products.push(p);
            }
          }
        },

        error: () => {}
      });
    }, 400);
  }

  // FILTER PRODUCTS
  getFilteredProducts(
    item: any
  ) {

    return this.products.filter(p => {

      const matchCategory =

        !item.category ||

        p.category?.name ===
        item.category;

      const matchSearch =

        !item.search ||

        p.name
          ?.toLowerCase()
          .includes(
            item.search
              .toLowerCase()
          );

      return (
        matchCategory &&
        matchSearch
      );
    });
  }

  // ADD ITEM
  addItem() {

    this.purchase.items.push({

      category: '',
      productId: '',
      search: '',
      quantity: 1,
      unitPrice: 0,
      sellPrice: 0
    });
  }

  // REMOVE ITEM
  removeItem(
    index: number
  ) {

    this.purchase.items.splice(
      index,
      1
    );
  }

  // TOTAL
  getTotal(): number {

    let total = 0;

    for (
      let item of this.purchase.items
    ) {

      total +=
        item.quantity *
        item.unitPrice;
    }

    return total;
  }

  // PROFIT
  getProfit(): number {

    let profit = 0;

    for (
      let item of this.purchase.items
    ) {

      profit += (

        (
          item.sellPrice -
          item.unitPrice
        ) *

        item.quantity
      );
    }

    return profit;
  }

  getDue(): number {

  return (

    this.getTotal()

    -

    (this.purchase.paidAmount || 0)

  );
}

  // SAVE PURCHASE
  savePurchase() {

    console.log(
  'SUPPLIER ID:',
  this.purchase.supplierId
);

console.log(
  'FULL PURCHASE:',
  this.purchase
);

  const payload = {

  supplierId:
    this.purchase.supplierId,

  paidAmount:
    this.purchase.paidAmount,

  supplierName:
    this.purchase.supplierName,

  supplierContact:
    this.purchase.supplierContact,

  totalAmount:
    this.getTotal(),

  items:

  this.purchase.items.map(
    (i: any) => ({

      productId:
        Number(i.productId),

      quantity:
        Number(i.quantity),

      unitPrice:
        Number(i.unitPrice),

      sellPrice:
        Number(i.sellPrice)
    })
  )
};

    console.log(
      'PURCHASE:',
      payload
    );

    this.http.post(

      `${this.apiUrl}/api/purchases`,

      payload

    )
    .subscribe({

      next: () => {

        alert(
          '✅ Purchase Saved'
        );

        this.purchase = {

  supplierId: null,

  supplierName: '',
  supplierContact: '',

  paidAmount: 0,

  items: [
    {
      category: '',
      productId: '',
      search: '',
      quantity: 1,
      unitPrice: 0,
      sellPrice: 0
    }
  ]
};
      },

      error: (err) => {

        console.log(
          'SAVE ERROR:',
          err
        );

        alert(
          '❌ Save Failed'
        );
      }
    });
  }
}